import React, { createRef, useState, useEffect, useMemo } from 'react';
import { DolarSIcon } from '../../components/Icons';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { useTranslation } from 'react-i18next';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import API from '../../API';
import { useLocation } from 'react-router';
import Loader from 'components/Loader';
import { ROOT, SETTINGS_FINANCIAL } from 'constants/routes';
import FileUpload from 'views/addPost/FileUpload';
import { useFormik } from 'formik';
import formik from './EditPostForm';
import { useDispatch, useSelector } from 'react-redux';
import { isImage } from 'helpers';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import ModelSubscription from '../../components/ModelSubscription';
import { Link, useHistory } from 'react-router-dom';
import { deletePostPhoto } from '../../reducers/feed/feed.actions';

const EditPost = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const ref = createRef();
  const { t } = useTranslation();
  const user = useSelector(selectAuthUser);
  const [lineValues, setvalue] = useState('');
  const [rows, setrows] = useState(2);
  const [minRows, setminRows] = useState(1);
  const [maxRows, setmaxRows] = useState(6);
  const [files, setfiles] = useState([]);
  const [body, setbody] = useState('');
  const [price, setprice] = useState(2);
  const [postPublic, setpostPublic] = useState(true);
  const [deleteMedia, setdeleteMedia] = useState([]);

  const initialValues = {
    files,
    body,
    price,
    postPublic,
    deleteMedia,
  };

  const {
    values,
    status,
    handleSubmit,
    errors,
    touched,
    handleChange,
    isSubmitting,
    setFieldValue,
    setStatus,
    resetForm,
    enableReinitialize,
    onSubmit,
  } = useFormik(formik({ dispatch, history, location, initialValues, deleteMedia }));

  useEffect(() => {
    API.get(`/post/${location.state}`)
      .then(res => {
        setfiles(res.files ? res.files : []);
        setbody(res.body ? res.body : '');
        setprice(res.price ? res.price : 2);
        setpostPublic(res.public ? res.public : true);
      })
      .catch(err => {
        console.log(err.message);
      });
  }, []);

  useEffect(() => {
    if (status && status.success) {
      setTimeout(() => {
        history.push(ROOT);
      }, 1000);
    }
  }, [status]);

  const emptyInput = values.body.trim().length === 0;
  const typingDirection = useMemo(() => {
   return emptyInput ? '' : 'auto';
   },[emptyInput]);

  const handleFileInputChange = files => {
    setFieldValue('files', [
      ...values.files,
      ...files.map(el => {
        const image = isImage(el.name);
        return { file: el, image: image ? URL.createObjectURL(el) : false };
      }),
    ]);
  };
  const classNames = [
    'disable-post-btn',
    values.body.trim() !== '' && 'add-post-save-button',
    values.files.length > 0 && 'add-post-save-button',
  ]
    .filter(e => e)
    .join(' ');

  const removeUploadedFile = (image, index) => {
    setFieldValue(
      'files',
      values.files.filter((el, ind) => {
        return index !== ind;
      })
    );
    if (!isNaN(image.id)) {
      setFieldValue('deleteMedia', [...values.deleteMedia, image]);
    }
  };

  const handleCheckChange = event => {
    let { checked } = event.target;
    setFieldValue('public', !checked);
  };

  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '77vh' }}>
      <Loader isLoadin={isLoading} height={40} size={35}>
        <div className="add-post-container">
          <h1>{t('Edit Post')}</h1>
        </div>
        <div className="add-post-cont ">
          {status && status.success ? (
            <React.Fragment>
              <p className="text-success text-center" style={{ fontSize: '1.1rem' }}>
                {t('Post was successfully edited.')}
              </p>
              <hr />
            </React.Fragment>
          ) : (
            <Form onSubmit={handleSubmit}>
              <div className="d-flex flex-column">
                <Loader isLoadin={isSubmitting} height={226} size={60}>
                  <div className="post-form-container">
                    <Form.Label className={values.body && 'filled'}>{t('text_about_post')}</Form.Label>
                    <FormControl 
                      dir={typingDirection}
                      as="textarea"
                      type="text"
                      ref={ref}
                      id="text"
                      rows={rows}
                      maxLength={1000}
                      name="body"
                      className="post-form-add-text"
                      style={{ resize: 'none', border: 'none', padding: 0, margin: 0, color: '#fff' }}
                      value={values.body}
                      onChange={handleChange}
                      isInvalid={touched.body && errors.body}
                    />
                    <Form.Control.Feedback type="invalid">{!!errors.body && errors.body}</Form.Control.Feedback>
                  </div>
                  <div style={{ margin: '5px 0', textAlign: 'right' }}>{values.body.length} / 1000</div>
                  {
                    <FileUpload
                      files={[...values.files]}
                      handleChange={handleFileInputChange}
                      handleRemove={removeUploadedFile}
                    />
                  }

                  <div>
                    {errors.files && (
                      <Form.Control.Feedback type="invalid" className="d-block">
                        {errors.files}
                      </Form.Control.Feedback>
                    )}
                    {status &&
                      status.errors &&
                      status.errors.map((err, key) => (
                        <Form.Control.Feedback key={key} type="invalid" className="d-block">
                          {err}
                        </Form.Control.Feedback>
                      ))}
                  </div>
                  <div className="buttons-wrapper add-post-footer">
                    <ButtonComponent
                      type={'button'}
                      btnText={t('Cancel')}
                      transparent={false}
                      customClass={'add-post-cancel-button'}
                      textClassName={'add-post-cancel-text'}
                      onClick={() => history.push(ROOT)}
                    />
                    <ButtonComponent
                      type="submit"
                      isBold={true}
                      btnText={t('Done edit')}
                      transparent={false}
                      customClass={classNames}
                      textClassName={'add-post-save-text'}
                    />
                  </div>
                </Loader>
              </div>
            </Form>
          )}
        </div>
      </Loader>
    </div>
  );
};

export default EditPost;
